import { useWhatIfPositions } from "@iliotech/data-wire/src/stores";
import { WhatIfPositionsTableCellProps } from "../WhatIfPositionsTable";
import { observer } from "mobx-react-lite";

const OriginalPercentageCell = ({ index }: WhatIfPositionsTableCellProps) => {
  const store = useWhatIfPositions();
  const currentPrice = store.getField<number>("oldPercentage", index);

  const formattedValue = currentPrice ? currentPrice.toFixed(1) : "";

  return <div>{formattedValue || 0}</div>;
};

export default observer(OriginalPercentageCell);
